function getCookie(cname) {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail: data,
    })
  )
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(
    new CustomEvent(name, {
      bubbles: false,
      detail: data,
    })
  )
}

const imageReady = imageOrArray => {
  if (!imageOrArray) {
    return Promise.resolve()
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray)
  return Promise.all(
    imageOrArray.map(image => {
      return new Promise(resolve => {
        if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
          setTimeout(() => {
            image.closest('motion-element')?.classList.remove('bls-loading-image')
            image.classList.remove('bls-loading-image')
            resolve()
          }, 100)
        } else {
          image.addEventListener('load', e => {
            e.currentTarget.closest('motion-element')?.classList.remove('bls-loading-image')
            e.currentTarget.classList.remove('bls-loading-image')
            resolve()
          })
        }
      })
    })
  )
}

class MotionElement extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    if (this.isHold) return
    this.preInitialize()
    if (this.dataset.noview) {
      return
    }
    if (!this.isConnected || !document.body.contains(this)) {
      setTimeout(() => {
        this.connectedCallback()
      }, 100)
      return
    }

    var _this = this
    let custom_margin = this.dataset.margin || '0px 0px -5px 0px'
    let rootElement = {}
    if (this.dataset.parent) {
      var parent = this.closest(`.${this.dataset.parent}`)
      rootElement = { root: parent }
      custom_margin = '0px 0px 0px 0px'
    }
    motion.inView(
      _this,
      async () => {
        if (!this.isInstant && this.mediaElements && this.hasAttribute('data-image')) {
          await imageReady(this.mediaElements)
        }
        setTimeout(() => {
          _this.initialize()
        }, 50)
      },
      { margin: custom_margin, ...rootElement }
    )
  }

  get isHold() {
    return this.hasAttribute('hold')
  }

  get Transition() {
    let transition = this.getAttribute('data-transition')?.split(',').map(Number)
    return transition || [0, 0, 0.3, 1]
  }

  get isInstant() {
    return this.hasAttribute('data-instantly')
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll('img, iframe, svg'))
  }

  get animationType() {
    return this.dataset.motion || 'fade-up'
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000
  }

  set animationDelay(value) {
    this.dataset.motionDelay = value
  }

  preInitialize() {
    if (this.isHold) return
    switch (this.animationType) {
      case 'fade-in':
        motion.animate(this, { opacity: 0.01 }, { duration: 0 })
        break

      case 'fade-up':
        motion.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 })
        break

      case 'fade-up-sm':
        motion.animate(this, { transform: 'translateY(1rem)', opacity: 0.01 }, { duration: 0 })
        break

      case 'fade-up-lg':
        motion.animate(this, { transform: 'translateY(4rem)', opacity: 0.01 }, { duration: 0 })
        break

      case 'zoom-in':
        motion.animate(this, { transform: 'scale(0.8)' }, { duration: 0 })
        break
      case 'zoom-in-lg':
        motion.animate(this, { transform: 'scale(0)' }, { duration: 0 })
        break

      case 'zoom-out':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 })
        break

      case 'zoom-out-sm':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 })
        break
      case 'zoom-out-lg':
        motion.animate(this, { transform: 'scale(1.07)' }, { duration: 0 })
        break
    }
  }

  async initialize() {
    if (this.isHold) return
    switch (this.animationType) {
      case 'fade-in':
        await motion.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'fade-up':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished
        break

      case 'fade-up-sm':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.3,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished
        break

      case 'fade-up-lg':
        await motion.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished
        break

      case 'zoom-in':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.3, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'zoom-in-lg':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 0.5, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'zoom-out':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.5, delay: this.animationDelay, easing: this.transition }
        ).finished
        break

      case 'zoom-out-sm':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: this.transition }
        ).finished
        break
      case 'zoom-out-lg':
        await motion.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: this.animationDelay, easing: this.transition }
        ).finished
        break
    }
  }
  refreshAnimation() {
    this.removeAttribute('hold')
    this.preInitialize()
    setTimeout(() => {
      this.initialize()
    }, 50) // Delay a bit to make animation re init properly.
  }
}
if (!customElements.get('motion-element')) customElements.define('motion-element', MotionElement)

class CopyButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', this.onClick.bind(this))
  }
  onClick() {
    const content = this.dataset.content
    if (!content) return
    navigator.clipboard.writeText(content)
    this.classList.add('copied')
  }
}
class CopyButtonTimeout extends CopyButton {
  onClick() {
    const content = this.dataset.content
    if (!content) return
    navigator.clipboard.writeText(content)
    this.classList.add('copied')

    setTimeout(() => {
      this.classList.remove('copied')
    }, 2500)
  }
}
customElements.define('copy-button-timeout', CopyButtonTimeout)

const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

class EmailForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.emailEl = this.querySelector('input[type="email"]')
    this.button = this.querySelector('button')
  }
  connectedCallback() {
    const emitByButton = this.dataset.emitSubmitByButton === "true";
    if (emitByButton) {
      this.button.addEventListener("click", this.onClick.bind(this));
    } else {
      this.form.addEventListener("submit", this.onClick.bind(this));
    }
    this.emailEl.addEventListener("input", this.removeError.bind(this));
  }
  removeError() {
    const errorTips = this.querySelector('.error-tips')
    const successTips = this.querySelector(".success-tips");
    if (errorTips) errorTips.remove();
    if (successTips) successTips.remove();
  }
  onSuccess() {
    const codeElement = this.querySelector("#discount-code");
    if (codeElement) {
      this.successHtml = codeElement.innerHTML;
      this.parentElement.innerHTML = this.successHtml;
    }
  }
  onClick(e) {
    e.preventDefault();
    const email = this.emailEl.value;
    this.removeError();
    if (!email) {
      const el = document.createElement("div");
      el.classList.add("error-tips");
      el.innerText = this.dataset.errorEmpty;
      this.appendChild(el);
      return;
    }
    if (!emailPattern.test(email)) {
      const el = document.createElement("div");
      el.classList.add("error-tips");
      el.innerText = this.dataset.errorInvalid;
      this.appendChild(el);
      return;
    }
    const sceneId = this.dataset.sceneId || 4;
    const noUseAjax = this.dataset.useAjax === "false";
    //提交时是否需要带上当前访问的页面url
    const submitEmailWithPageUrl = this.dataset.submitEmailWithPageUrl === "true";
    //当前的标签tag名称
    const tagName = this.dataset.emailTagName;
    //
    this.onSuccess();
    if (noUseAjax) {
      const myForm = this.form;
      if (window.Shopify.captcha) {
        window.Shopify.captcha.protect(myForm, () => {
          myForm.submit();
        });
      }
    } else {
      let host = window.__MC__CONFIG__.apiUrl;
      let url = `${host}/api/station/activity/collectEmail?email=${email}&scene=${sceneId}`;
      if (this.dataset.subscribe == "1") {
        url += `&subscribe=1`;
      }
      if (tagName) {
        url += `&tagValue=${tagName}`;
      }
      if (submitEmailWithPageUrl) {
        const wholePath = window.location.origin + window.location.pathname
        url += `&submitUrl=${wholePath}`;
      }
      fetch(url, {
        headers: window.__MC__CONFIG__.headers
      })
        .then((res) => res.json())
        .then((res) => {
          const { code } = res || {};
          if (this.dataset.successText && code == "200") {
            // Show success message
            const el = document.createElement("div");
            el.classList.add("success-tips");
            el.innerText = this.dataset.successText;
            this.appendChild(el);
          }
        });
    }
  }
}

if (!customElements.get('email-form')) customElements.define('email-form', EmailForm)

class PopupBase extends HTMLElement {
  constructor() {
    super()
    this.customClass = this.dataset.customClass
    this.modal = null
  }

  initPopup(content, customClass) {
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [this.customClass, customClass],
    })
    this.modal.setContent(content)
    this.modal.open()
  }

  onClose() {
    this.modal.close()
  }
}

class PopupRules extends PopupBase {
  constructor() {
    super()
    this.popupPopupHtml = this.querySelector('#content').innerHTML
  }

  connectedCallback() {
    this.init()
  }
  disconnectedCallback() {
    if (this.modal) {
      this.modal.destroy()
      this.modal = null
    }
  }
  init() {
    if (this.popupPopupHtml) {
      this.addEventListener('click', this.onClick.bind(this))
    }
  }
  onClick() {
    if (!this.popupPopupHtml) return
    if (this.modal) {
      this.modal.open()
      return
    }
    this.initPopup(this.popupPopupHtml, 'rules-popup')
  }
}
customElements.define('popup-rules', PopupRules)

class LoadMore extends HTMLElement {
  constructor() {
    super()
    this.isMobile = window.luteUtil.isMobile
    this.handleScreen()

    this.sectionId = this.getAttribute('data-section-id')
    this.path = this.getAttribute('data-path')
    this.total = parseInt(this.getAttribute('data-total'))
    this.currentPage = 1
    this.loadMorePagination = this.querySelector('.t4s-prs-pagination')
    this.loadMoreBtn = this.loadMorePagination.querySelector('.t4s-loadmore-btn')
    this.currentPageEl = this.loadMorePagination.querySelector('[data-current-bar]')
    this.loadMoreBar = this.loadMorePagination.querySelector('.t4s-lm-bar--current')

    this.init()
  }

  handleScreen() { }

  init() {
    this.addEventListeners()
  }

  addEventListeners() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', event => {
        event.preventDefault()
        this.loadMoreProducts()
      })
    }
  }

  getSectionInnerHTML(html, selector) {
    return (
      new DOMParser().parseFromString(html, 'text/html').querySelector(`#${selector}`)?.innerHTML ||
      ''
    )
  }

  updateEvents() {
    T4SThemeSP.reinitProductGridItem()
  }
  async loadMoreProducts() {
    if (this.currentPage >= this.total) return
    try {
      this.loadMoreBtn.classList.add('is--loading')

      const response = await fetch(
        `${this.path}/page-${this.currentPage}?section_id=${this.sectionId}`
      )
      if (!response.ok) return

      const data = await response.text()
      const newProducts = this.getSectionInnerHTML(data, 'goods_list')

      if (newProducts) {
        this.querySelector('.load-more-container').insertAdjacentHTML('beforeend', newProducts)
        this.currentPage++
        this.updateEvents()
      }

      if (this.currentPage >= this.total) {
        this.loadMorePagination.remove()
      } else {
        this.currentPageEl.innerHTML = this.currentPage
        this.loadMoreBar.style.width = `${(this.currentPage / this.total) * 100}%`
      }
    } finally {
      this.loadMoreBtn.classList.remove('is--loading')
    }
  }
}
if (!customElements.get('load-more')) customElements.define('load-more', LoadMore)

class LoadMoreProduct extends LoadMore {
  constructor() {
    super()

    this.currentOffset = parseInt(
      this.getAttribute(this.isMobile ? 'data-offset-mobile' : 'data-offset')
    )
    this.loadCount =
      parseInt(this.getAttribute(this.isMobile ? 'data-load-count-mobile' : 'data-load-count')) || 6
  }

  handleScreen() {
    if (this.isMobile) {
      const pcEls = [...this.querySelectorAll('[data-pc]')]
      pcEls.forEach(el => el.remove())
    } else {
      const mobileEls = [...this.querySelectorAll('[data-mobile]')]
      mobileEls.forEach(el => el.remove())
    }
  }

  async loadMoreProducts() {
    if (this.currentOffset >= this.total) return
    try {
      this.loadMoreBtn.classList.add('is--loading')

      const response = await fetch(
        `${this.path}/offset-${this.currentOffset}|mobile-${window.luteUtil.isMobile}?section_id=${this.sectionId}`
      )
      if (!response.ok) return

      const data = await response.text()
      const newProducts = this.getSectionInnerHTML(data, 'goods_list')

      if (newProducts) {
        this.querySelector('.load-more-container').insertAdjacentHTML('beforeend', newProducts)
        this.currentOffset += this.loadCount
        this.updateEvents()
      }

      if (this.currentOffset >= this.total) {
        this.loadMorePagination.remove()
      } else {
        this.currentPageEl.innerHTML = this.currentOffset
        this.loadMoreBar.style.width = `${(this.currentOffset / this.total) * 100}%`
      }
    } finally {
      this.loadMoreBtn.classList.remove('is--loading')
    }
  }
}

if (!customElements.get('load-more-product'))
  customElements.define('load-more-product', LoadMoreProduct)

class TabsNavigation extends HTMLElement {
  constructor() {
    super()
    this._onClick = this._onClick.bind(this)
    this._currentAnimation = null
  }

  connectedCallback() {
    this.container = this.parentElement
    this.buttons = Array.from(this.querySelectorAll('.tab-button'))
    this.navWrapper = this.querySelector('.tabs-wrapper')
    this.scrollContainer = this.querySelector('.tabs-scroll-container')

    // 创建 slider 指示器
    this.slider = document.createElement('div')
    this.slider.classList.add('slider')
    this.navWrapper.appendChild(this.slider)

    // 事件委托，只绑定一个监听器
    this.addEventListener('click', this._onClick)

    // 初始化时确保第一个标签是激活状态
    const firstTabId = this.buttons[0]?.dataset.tabId
    if (firstTabId) {
      this.activateTab(firstTabId, this.buttons[0])
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick)
    if (this._currentAnimation) {
      this._currentAnimation.cancel()
      this._currentAnimation = null
    }
  }

  _onClick(event) {
    const clickedButton = event.target.closest('.tab-button')
    if (!clickedButton || !this.contains(clickedButton)) return
    const tabId = clickedButton.dataset.tabId
    if (tabId) this.activateTab(tabId, clickedButton)
  }

  updateActive(button) {
    const { offsetLeft, offsetWidth } = button
    const clipRight = offsetLeft + offsetWidth
    const containerOffsetWidth = this.navWrapper.offsetWidth
    const right = Number(100 - (clipRight / containerOffsetWidth) * 100).toFixed()
    const left = Number((offsetLeft / containerOffsetWidth) * 100).toFixed()
    this.slider.style.clipPath = `inset(0 ${right}% 0 ${left}% round 99px)`
  }

  moveButtonToCenter(button) {
    if (!this.scrollContainer) return
    const buttonRect = button.getBoundingClientRect()
    const wrapperRect = this.navWrapper.getBoundingClientRect()
    const scrollContainerRect = this.scrollContainer.getBoundingClientRect()
    const scrollLeft =
      buttonRect.left - wrapperRect.left - (scrollContainerRect.width - buttonRect.width) / 2
    this.scrollContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth',
    })
  }

  activateTab(tabId, activeButton) {
    // 更新标签按钮状态
    this.buttons.forEach(button => {
      const isActive = button === activeButton
      button.classList.toggle('active', isActive)
      button.setAttribute('aria-selected', isActive ? 'true' : 'false')
      if (isActive) {
        this.updateActive(button)
      }
    })

    // 取消正在进行的动画，防止竞态
    if (this._currentAnimation) {
      this._currentAnimation.cancel()
      this._currentAnimation = null
    }

    const from = this.container.querySelector('.tab-content-container.active')
    const to = this.container.querySelector(`[data-tab-content="${CSS.escape(tabId)}"]`)
    if (!to) return

    if (from && from !== to) {
      this._currentAnimation = from.animate({ opacity: [1, 0] }, { duration: 250, easing: 'ease' })
      this._currentAnimation.onfinish = () => {
        this._currentAnimation = null
        from.classList.remove('active')
        to.classList.add('active')
        to.animate({ opacity: [0, 1] }, { duration: 250, easing: 'ease' })
      }
    } else if (!from) {
      // 首次激活，无需淡出
      to.classList.add('active')
    }

    this.moveButtonToCenter(activeButton)
    this.dispatchEvent(
      new CustomEvent('tab-changed', {
        bubbles: true,
        detail: { tabId },
      })
    )
  }
}

// 注册自定义元素
customElements.define('tabs-navigation', TabsNavigation)
/**
 * 基础倒计时组件，提供简单的天、时、分、秒显示功能
 */
class BaseCountdown extends HTMLElement {
  constructor() {
    super()
    // 定时器引用，用于清除
    this.endTime = this.dataset.endTime
    this.timer = null
  }

  connectedCallback() {
    if (!this.endTime) {
      console.warn('Countdown end date and time not set')
      return
    }

    this.setEndTime(this.endTime)
  }

  setEndTime(endTime) {
    this.endTime = endTime
    this.dataset.endTime = endTime

    const res = Date.parse(endTime)
    if (isNaN(res)) {
      console.warn('Invalid date format')
      return
    }

    // 初次立即更新
    this.updateCountdown()

    // 设置每秒更新一次
    this.timer = setInterval(() => this.updateCountdown(), 1000)
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  /**
   * 计算剩余时间
   */
  calculateRemainingTime() {
    const endDate = Date.parse(this.endTime)
    const now = Date.now()
    const diff = endDate - now

    if (diff <= 0) {
      this.timer && clearInterval(this.timer)
      return {
        isEnded: true,
        days: 0,
        hours: 0,
        fullHours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
        diff: 0,
      }
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const fullHours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    return { isEnded: false, days, hours, fullHours, minutes, seconds, diff }
  }

  /**
   * 更新倒计时显示 - 子类需要实现此方法
   */
  updateCountdown() {
    const time = this.calculateRemainingTime()
    // 如果倒计时结束
    if (time.isEnded) {
      // 触发事件通知倒计时结束
      this.dispatchEvent(new CustomEvent('countdown-ended'))
      return
    }

    // 触发事件通知倒计时更新
    this.dispatchEvent(new CustomEvent('countdown-updated', { detail: time }))
  }
}
// 注册基础倒计时组件
customElements.define('base-countdown', BaseCountdown)

class SimpleCountdown extends BaseCountdown {
  constructor() {
    super()
    this.isFullHours = this.hasAttribute('full-hours')
    // 获取显示元素的引用
    this.daysEl = this.querySelector('[data-days]')
    this.hoursEl = this.querySelector('[data-hours]')
    this.minutesEl = this.querySelector('[data-minutes]')
    this.secondsEl = this.querySelector('[data-seconds]')
    this.updateElement()
  }

  updateElement() {
    this.addEventListener('countdown-updated', function (e) {
      this.updateDisplay(e.detail)
    })
  }

  updateDisplay(data) {
    window.luteUtil.rIC(() => {
      if (this.isFullHours) {
        if (this.hoursEl) this.hoursEl.textContent = String(data.fullHours).padStart(2, '0')
      } else {
        if (this.daysEl) this.daysEl.textContent = String(data.days).padStart(2, '0')
        if (this.hoursEl) this.hoursEl.textContent = String(data.hours).padStart(2, '0')
      }
      if (this.minutesEl) this.minutesEl.textContent = String(data.minutes).padStart(2, '0')
      if (this.secondsEl) this.secondsEl.textContent = String(data.seconds).padStart(2, '0')
    })
  }
}

customElements.define('simple-countdown', SimpleCountdown)

class DaylyCountdown extends BaseCountdown {
  constructor() {
    super()
    this.hoursEl = this.querySelector('[data-hours]')
    this.minutesEl = this.querySelector('[data-minutes]')
    this.secondsEl = this.querySelector('[data-seconds]')
    // 获取显示元素的引用
    this.tz = this.dataset.tz || 'America/New_York'
    this.getTzEndOfToday().then(res => {
      this.endTime = res
      this.setEndTime(this.endTime)
      this.updateElement()
    })
  }

  async getTzEndOfToday() {
    const nowInTZ = dayjs().tz(this.tz).endOf('day').format()
    return nowInTZ
  }

  updateElement() {
    this.addEventListener('countdown-updated', function (e) {
      this.updateDisplay(e.detail)
    })
  }

  updateDisplay(data) {
    window.luteUtil.rIC(() => {
      if (this.hoursEl) this.hoursEl.textContent = String(data.fullHours).padStart(2, '0')
      if (this.minutesEl) this.minutesEl.textContent = String(data.minutes).padStart(2, '0')
      if (this.secondsEl) this.secondsEl.textContent = String(data.seconds).padStart(2, '0')
    })
  }
}

customElements.define('dayly-countdown', DaylyCountdown)

class SwiperCarousel extends HTMLElement {
  constructor() {
    super()
    this._createFlickity()
  }
  async disconnectedCallback() {
    if (this.swiper) {
      const swiperInstance = await this.swiper
      swiperInstance.destroy()
    }
  }
  get swiperConfig() {
    return JSON.parse(this.getAttribute('swiper-config'))
  }
  get swiperInstance() {
    return this.swiper
  }
  async next() {
    ; (await this.swiperInstance).slideNext()
  }
  async previous() {
    ; (await this.swiperInstance).slidePrev()
  }
  async select(indexOrSelector) {
    ; (await this.swiperInstance).slideTo(indexOrSelector)
  }
  async setDraggable(draggable) {
    const swiperInstance = await this.swiper
    swiperInstance.params.allowTouchMove = draggable
    swiperInstance.update()
  }
  async reload() {
    const swiperInstance = await this.swiper
    swiperInstance.destroy()
    if (this.swiperConfig['cellSelector']) {
      Array.from(this.children)
        .sort((a, b) =>
          parseInt(a.getAttribute('data-original-position')) >
            parseInt(b.getAttribute('data-original-position'))
            ? 1
            : -1
        )
        .forEach(node => this.appendChild(node))
    }
    this._createFlickity()
  }
  async _createFlickity() {
    this.swiper = new Promise(async resolve => {
      const swiperInstance = new Swiper(this, {
        ...this.swiperConfig,
        on: {
          beforeInit(swiper) {
            triggerEvent(swiper.el, 'swiper:beforeInit', swiper)
          },
        },
      })
      resolve(swiperInstance)
    })
  }

  async _preloadNextImage() {
    var _a
    const swiperInstance = await this.swiper
    if (swiperInstance.selectedElement.nextElementSibling) {
      ; (_a = swiperInstance.selectedElement.nextElementSibling.querySelector('img')) == null
        ? void 0
        : _a.setAttribute('loading', 'eager')
    }
  }
}
if (!customElements.get('swiper-carousel')) customElements.define('swiper-carousel', SwiperCarousel)

let oldTip = null
function openTipDialog(tips) {
  if (oldTip) {
    document.body.removeChild(oldTip)
    oldTip = null
  }
  const tipDialog = (oldTip = document.createElement('div'))
  tipDialog.classList.add('tip-dialog')
  tipDialog.innerHTML = `<div class="tip-dialog-content">${tips}</div>`
  document.body.appendChild(tipDialog)
  setTimeout(() => {
    tipDialog.classList.add('show')
  }, 4)

  setTimeout(() => {
    if (!tipDialog) return
    tipDialog.classList.remove('show')
    setTimeout(() => {
      document.body.removeChild(tipDialog)
      oldTip = null
    }, 600)
  }, 2000)
}
window.openTipDialog = openTipDialog

class MemberHubDot extends HTMLElement {
  constructor() {
    super()
    this.isLogined = false
  }

  connectedCallback() {
    window.luteUtil.rIC(() => {
      const hasDot = getCookie('momcozy-member-hub-tag')
      if (!hasDot) {
        this.setClass()
        this.registerEvent()
      }
    })
  }

  setClass() {
    const hasDot = getCookie('momcozy-member-hub-tag')

    if (!hasDot || !this.isLogined) {
      this.classList.add('hub-dot')
    } else {
      this.classList.remove('hub-dot')
    }
  }

  registerEvent() {
    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.visibilityState === 'visible') {
          this.setClass()
        }
      },
      { once: true }
    )

    // 监听body 上有没有 .momcozy-logined 类名
    let observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          const classList = mutation.target.classList
          this.isLogined = classList.contains('momcozy-logined')
          this.setClass()
          if (this.isLogined) {
            observer.disconnect()
            // 注销MutationObserver
            observer = null
          }
        }
      })
    })
    observer.observe(document.body, { attributes: true })
  }
}
customElements.define('member-hub-dot', MemberHubDot)

class QuicklyBuyNowButton extends HTMLElement {
  constructor() {
    super()
    document.addEventListener('DOMContentLoaded', this.init.bind(this))
  }
  init() {
    const that = this
    that.variantId = this.getAttribute('variant-id')
    $(document).on('variant:changed', function (evt) {
      const currentVariant = evt.currentVariant
      console.log('Variant changed event received in QuicklyBuyNowButton:', currentVariant)
      that.variantId = currentVariant.id
      that.setAttribute('variant-id', that.variantId)
      //如果是库存为0且不允许超卖则隐藏按钮
      that.style.display = (currentVariant.inventory_quantity <= 0 && currentVariant.inventory_policy === 'deny') || currentVariant.available !== true ? 'none' : 'flex'
    })
    that.setAttribute('variant-id', that.variantId)
    that.addEventListener('click', that.onClick.bind(that))
    console.log('QuicklyBuyNowButton initialized with variant ID:', this.variantId)
  }
  onClick() {
    const variantId = this.variantId
    const quantityInput = document.querySelector('input[name="quantity"][data-current-qty]')
    const quantity = quantityInput ? quantityInput.value : 1
    if (!variantId) return

    const bgg = document.querySelector('buy-get-gift');
    if (bgg) {
      bgg.onBuyNow({ id: variantId, quantity });
      return;
    }

    const url = `/cart/${variantId}:${quantity}`
    window.location.href = url
  }
}
customElements.define('quickly-buy-now-button', QuicklyBuyNowButton)

window.luteTheme = window.luteTheme || {}

function refreshCartDrawer() {
  return new Promise((res, rej) => {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      success: function () {
        // 将更新后的购物车内容渲染到购物车抽屉的显示区域
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh:opend', { bubbles: true })
        )
        res(true)
      },
      error() {
        rej(false)
      },
    })
  })
}

async function addStarProduct(data, cb) {
  const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  const json = await response.json()
  if (cb) cb()
  return await refreshCartDrawer(json)
}

window.luteTheme.addStarProduct = addStarProduct;

// ─── Gift ATC / Quickshop 自定义元素 ─────────────────────────────────────────
// 这些元素需要在任意页面可用（cart-gwp.js 不一定加载），因此放在 components.js 中。
// 对 GWP 接口的调用通过 window.luteTheme.gwp.* 进行，对 B2G 接口通过 window.luteTheme.b2g.* 进行。
(function () {
  // ─── 公共辅助 ───────────────────────────────────────────────────────────────

  function giftGetRoute(path) {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + path
  }

  // 标记内部请求，避免 GWP / B2G fetch 拦截器触发 reconcile
  function giftWithInternalCartMutation(fn) {
    var gwp = window.luteTheme && window.luteTheme.gwp
    if (gwp && gwp.withInternalCartMutation) return gwp.withInternalCartMutation(fn)
    return fn()
  }

  // ─── BaseAtcButton ──────────────────────────────────────────────────────────

  class BaseAtcButton extends HTMLElement {
    constructor() {
      super()
      this.isLoading = false
      this.variantChangeHandler = this.handleVariantChange.bind(this)
    }

    connectedCallback() {
      this.style.display = 'block'
      this.addEventListener('click', this)
      document.addEventListener('variant:changed', this.variantChangeHandler)
      this.getForm().addEventListener('change', this.variantChangeHandler)

      if (window.jQuery_T4NT) window.jQuery_T4NT(document).on('variant:changed.gwpGiftAtc', this.variantChangeHandler)
      if (window.$ && window.$ !== window.jQuery_T4NT) window.$(document).on('variant:changed.gwpGiftAtc', this.variantChangeHandler)

      this.syncDisabledState()
    }

    disconnectedCallback() {
      this.removeEventListener('click', this)
      document.removeEventListener('variant:changed', this.variantChangeHandler)
      this.getForm().removeEventListener('change', this.variantChangeHandler)

      if (window.jQuery_T4NT) window.jQuery_T4NT(document).off('variant:changed.gwpGiftAtc', this.variantChangeHandler)
      if (window.$ && window.$ !== window.jQuery_T4NT) window.$(document).off('variant:changed.gwpGiftAtc', this.variantChangeHandler)
    }

    getButton() {
      return this.getElementsByTagName('button')[0]
    }

    getForm() {
      var button = this.getButton()
      return (button && button.form) || this.closest('form') || this
    }

    getSelectedVariantOption() {
      var form = this.getForm()
      var select = form && form.elements && form.elements.id
      if (!select || select.tagName !== 'SELECT') return null
      return select.options[select.selectedIndex] || null
    }

    isSelectedVariantAvailable(event) {
      var variant = event && event.detail && event.detail.variant
      if (!variant && event && event.currentVariant) variant = event.currentVariant
      if (variant && typeof variant.available !== 'undefined') return Boolean(variant.available)

      var selectedOption = this.getSelectedVariantOption()
      if (!selectedOption) {
        var button = this.getButton()
        return button ? !button.disabled && button.getAttribute('aria-disabled') !== 'true' : true
      }

      return !selectedOption.disabled && !selectedOption.classList.contains('is--sold-out')
    }

    handleVariantChange(event) {
      this.syncDisabledState(this.isSelectedVariantAvailable(event))
    }

    syncDisabledState(isAvailable) {
      var button = this.getButton()
      if (!button || this.isLoading) return

      var selectedVariantAvailable = typeof isAvailable === 'boolean' ? isAvailable : this.isSelectedVariantAvailable()
      button.disabled = !selectedVariantAvailable
      if (selectedVariantAvailable) {
        button.removeAttribute('aria-disabled')
      } else {
        button.setAttribute('aria-disabled', 'true')
      }
    }

    setLoading(button, isLoading) {
      this.isLoading = isLoading
      button.disabled = isLoading
      button.setAttribute('aria-busy', isLoading ? 'true' : 'false')
      button.classList.toggle('is--loading', isLoading)
    }

    closeQuickshop() {
      if (window.jQuery_T4NT) {
        window.jQuery_T4NT(document.body).trigger('modalt4s:closed')
        return
      }
      if (window.$) {
        window.$('body').trigger('modalt4s:closed')
        return
      }
      document.body.dispatchEvent(new CustomEvent('modalt4s:closed', { bubbles: true }))
    }
  }

  // ─── GWP 赠品提交按钮 ────────────────────────────────────────────────────────

  class GiftAtcButton extends BaseAtcButton {
    async handleEvent(event) {
      if (event.type !== 'click') return

      var button = event.composedPath().find(function (el) { return el && el.tagName === 'BUTTON' })
      if (!button) return

      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      if (this.isLoading || button.disabled || button.getAttribute('aria-disabled') === 'true') return

      var form = button.form
      var formData = form ? new FormData(form) : new FormData()
      var variantId = formData.get('id')
      var activity = { id: this.dataset.giftActivityId || '' }
      var gift = { tierGiftId: this.dataset.giftTierGiftId || '' }
      var datasetGiftQuantity = Number(this.dataset.giftQuantity || 0)

      if (!variantId) return

      var gwp = window.luteTheme && window.luteTheme.gwp
      if (!gwp) {
        console.warn('[gift-atc-button] window.luteTheme.gwp not available')
        return
      }

      this.setLoading(button, true)

      try {
        var cart = await gwp.getCart({ force: true })
        var autoGiftItems = (cart.items || []).filter(gwp.isAutoGiftItem)
        var currentGiftQuantity = autoGiftItems.reduce(function (total, item) {
          return total + Number(item.quantity || 0)
        }, 0) || 1
        var quantity = datasetGiftQuantity > 0 ? datasetGiftQuantity : currentGiftQuantity

        await gwp.removeAutoGiftItems(autoGiftItems)
        var response = await gwp.addAutoGiftItem(activity, gift, variantId, quantity)
        var json = await response.json()
        if (!response.ok) throw json

        this.dispatchEvent(new CustomEvent('gift-atc:item-added', {
          bubbles: true,
          detail: { productId: form && form.dataset.productid, variantId, quantity, response: json },
        }))

        this.closeQuickshop()
        gwp.refreshCartAfterGiftChange()
      } catch (error) {
        this.dispatchEvent(new CustomEvent('gift-atc:error', { bubbles: true, detail: { error } }))
      } finally {
        this.setLoading(button, false)
      }
    }
  }

  // ─── B2G 赠品提交按钮 ─────────────────────────────────────────────────────────

  class B2gAtcButton extends BaseAtcButton {
    async handleEvent(event) {
      if (event.type !== 'click') return

      var button = event.composedPath().find(function (el) { return el && el.tagName === 'BUTTON' })
      if (!button) return

      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      if (this.isLoading || button.disabled || button.getAttribute('aria-disabled') === 'true') return

      var form = button.form
      var formData = form ? new FormData(form) : new FormData()
      var variantId = formData.get('id')
      var activityId = this.dataset.giftActivityId || ''
      var giftGiftId = this.dataset.giftGiftId || ''
      var giftParentKey = this.dataset.giftParentKey || ''
      var datasetGiftQuantity = Number(this.dataset.giftQuantity || 0)

      if (!variantId) return

      this.setLoading(button, true)

      try {
        var gwp = window.luteTheme && window.luteTheme.gwp
        var cart = gwp && gwp.getCart
          ? await gwp.getCart({ force: true })
          : await fetch(giftGetRoute('cart.js'), { credentials: 'same-origin' }).then(function (r) { return r.json() })

        // 找到 parent key 对应的旧 B2G 赠品行
        var oldB2gItems = (cart.items || []).filter(function (item) {
          var props = item.properties || {}
          if (String(props._b2g || '') !== 'true') return false
          if (giftParentKey) {
            var parentRel = item.parent_relationship || item.parentRelationship
            var parentKey = String(parentRel && (parentRel.parent_key || parentRel.parentKey) || '')
            return parentKey === giftParentKey
          }
          return String(props._b2g_activity_id || '') === activityId
        })

        var oldQuantity = oldB2gItems.reduce(function (total, item) {
          return total + Number(item.quantity || 0)
        }, 0)
        var quantity = datasetGiftQuantity > 0 ? datasetGiftQuantity : (oldQuantity || 1)

        // 移除旧赠品行（标记为两个拦截器的内部请求，避免触发 reconcile）
        if (oldB2gItems.length) {
          var updates = oldB2gItems.reduce(function (result, item) {
            result[item.key] = 0
            return result
          }, {})
          await giftWithInternalCartMutation(function () {
            return fetch(giftGetRoute('cart/update.js'), {
              method: 'POST',
              credentials: 'same-origin',
              __luteGwpInternal: true,
              __luteB2gInternal: true,
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates }),
            })
          })
        }

        // 添加新变体，写入 B2G properties
        var addBody = {
          items: [{
            id: Number(variantId),
            quantity: quantity,
            properties: {
              _b2g: 'true',
              _b2g_activity_id: activityId,
              _b2g_gift_id: giftGiftId,
            },
          }],
        }
        if (giftParentKey) addBody.items[0].parent_line_key = giftParentKey

        var response = await giftWithInternalCartMutation(function () {
          return fetch(giftGetRoute('cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            __luteGwpInternal: true,
            __luteB2gInternal: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addBody),
          })
        })

        var json = await response.json()
        if (!response.ok) throw json

        this.dispatchEvent(new CustomEvent('gift-atc:item-added', {
          bubbles: true,
          detail: { productId: form && form.dataset.productid, variantId, quantity },
        }))

        this.closeQuickshop()
        if (window.luteTheme && window.luteTheme.b2g && window.luteTheme.b2g.reconcile) {
          window.luteTheme.b2g.reconcile()
        }
        var gwp = window.luteTheme && window.luteTheme.gwp
        if (gwp && gwp.refreshCartAfterGiftChange) {
          gwp.refreshCartAfterGiftChange()
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'b2g' } }))
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'b2g' } }))
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'b2g' } }))
        }
      } catch (error) {
        this.dispatchEvent(new CustomEvent('gift-atc:error', { bubbles: true, detail: { error } }))
      } finally {
        this.setLoading(button, false)
      }
    }
  }

  // ─── GiftQuickshopOpener ─────────────────────────────────────────────────────

  class GiftQuickshopOpener extends HTMLElement {
    static cache = new Map()

    connectedCallback() {
      this.addEventListener('click', this)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this)
    }

    async handleEvent(event) {
      var trigger = event.composedPath().find(function (element) {
        return element && element.hasAttribute && element.hasAttribute('data-gift-quickshop')
      })

      if (!trigger) return

      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()

      if (trigger.classList.contains('is--loading')) return

      var productUrl = trigger.getAttribute('href')
      var sectionId = trigger.getAttribute('data-section-id') || 'main-qs-gift'
      var productId = trigger.getAttribute('data-id') || productUrl
      var giftVariantId = trigger.getAttribute('data-gift-variant-id') || ''
      var giftActivityId = trigger.getAttribute('data-gift-activity-id') || ''
      var giftTierGiftId = trigger.getAttribute('data-gift-tier-gift-id') || ''
      var giftQuantity = trigger.getAttribute('data-gift-quantity') || ''
      var giftParentKey = trigger.getAttribute('data-gift-parent-key') || ''
      var giftMode = trigger.getAttribute('data-gift-mode') || 'gift'
      var giftGiftId = trigger.getAttribute('data-gift-gift-id') || ''
      var cacheKey = `${sectionId}${productId}${giftVariantId}${giftActivityId}${giftTierGiftId}${giftQuantity}${giftMode}`
      var cachedHtml = GiftQuickshopOpener.cache.get(cacheKey)

      window.T4SThemeSP = window.T4SThemeSP || {}
      window.T4SThemeSP.isEditCartReplace = false
      window.T4SThemeSP.iDVariantEdit = productId
      window.T4SThemeSP.keyVariantEdit = null

      if (cachedHtml) {
        this.open(cachedHtml, sectionId, giftActivityId, giftTierGiftId, giftQuantity, giftParentKey, giftMode, giftGiftId)
        return
      }

      trigger.classList.add('is--loading')

      try {
        var quickshopUrl = new URL(productUrl, window.location.origin)
        if (giftVariantId) quickshopUrl.searchParams.set('variant', giftVariantId)
        quickshopUrl.searchParams.set('section_id', sectionId)
        quickshopUrl.searchParams.set('fetch', '1')
        quickshopUrl.searchParams.set('style', '1')
        quickshopUrl.searchParams.set('mode', giftMode)
        var response = await fetch(quickshopUrl.toString())
        var html = await response.text()
        var rawHtml = window.IsDesignMode ? this.templateHtml(html) : this.sectionHtml(html)

        GiftQuickshopOpener.cache.set(cacheKey, rawHtml)
        this.open(rawHtml, sectionId, giftActivityId, giftTierGiftId, giftQuantity, giftParentKey, giftMode, giftGiftId)
      } catch (error) {
        console.error('Failed to load gift quickshop:', error)
      } finally {
        trigger.classList.remove('is--loading')
      }
    }

    sectionHtml(html) {
      var template = document.createElement('template')
      template.innerHTML = html

      return (template.content.firstElementChild && template.content.firstElementChild.innerHTML) || html
    }

    templateHtml(html) {
      var template = document.createElement('template')
      template.innerHTML = html
      var sectionTemplate = Array.from(template.content.children).find(function (element) {
        return element.tagName === 'TEMPLATE'
      })

      return (sectionTemplate && sectionTemplate.innerHTML) || this.sectionHtml(html)
    }

    withGiftActivityId(html, giftActivityId, giftTierGiftId, giftQuantity, giftParentKey, giftMode, giftGiftId) {
      if (!giftActivityId && !giftTierGiftId && !giftQuantity && !giftParentKey && !giftMode && !giftGiftId) return html

      var template = document.createElement('template')
      template.innerHTML = html

      // B2G 模式注入 b2g-atc-button，GWP 模式注入 gift-atc-button
      var selector = giftMode === 'b2g' ? 'b2g-atc-button' : 'gift-atc-button'
      template.content.querySelectorAll(selector).forEach(function (element) {
        if (giftActivityId) element.dataset.giftActivityId = giftActivityId
        if (giftTierGiftId) element.dataset.giftTierGiftId = giftTierGiftId
        if (giftQuantity) element.dataset.giftQuantity = giftQuantity
        if (giftParentKey) element.dataset.giftParentKey = giftParentKey
        if (giftMode) element.dataset.giftMode = giftMode
        if (giftGiftId) element.dataset.giftGiftId = giftGiftId
      })

      return template.innerHTML
    }

    open(html, sectionId, giftActivityId, giftTierGiftId, giftQuantity, giftParentKey, giftMode, giftGiftId) {
      html = this.withGiftActivityId(html, giftActivityId, giftTierGiftId, giftQuantity, giftParentKey, giftMode, giftGiftId)
      window.T4SThemeSP.NTpopupInline(html, sectionId, () => this.initQuickshop(), 't4s-opening-qs')
      document.body.dispatchEvent(new CustomEvent('modalt4s:opened', { bubbles: true }))
    }

    initQuickshop() {
      var quickShop = Array.from(document.getElementsByClassName('t4s-product-quick-shop')).find(function (element) {
        return !element.classList.contains('is-t4s-pr-created')
      })

      if (!quickShop) return

      quickShop.classList.add('is-t4s-pr-created')

      if (window.T4SThemeSP && window.T4SThemeSP.Product) new window.T4SThemeSP.Product(quickShop)
      if (window.T4SThemeSP && window.T4SThemeSP.PopupMFP) window.T4SThemeSP.PopupMFP()
      if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init()
      if (window.T4SThemeSP && window.T4SThemeSP.Wishlist && window.T4SThemeSP.Wishlist.updateAll) window.T4SThemeSP.Wishlist.updateAll()
      if (window.T4SThemeSP && window.T4SThemeSP.Compare && window.T4SThemeSP.Compare.updateAll) window.T4SThemeSP.Compare.updateAll()
      if (window.T4SThemeSP && window.T4SThemeSP.ProductItem && window.T4SThemeSP.ProductItem.reloadReview) window.T4SThemeSP.ProductItem.reloadReview()
      if (window.T4SThemeSP && window.T4SThemeSP.ProductItem && window.T4SThemeSP.ProductItem.reloadReviewCurent) window.T4SThemeSP.ProductItem.reloadReviewCurent()
      if (window.T4SThemeSP && window.T4SThemeSP.Tooltip) window.T4SThemeSP.Tooltip()

      document.body.dispatchEvent(new CustomEvent('currency:update', { bubbles: true }))
    }
  }

  if (!customElements.get('gift-atc-button')) customElements.define('gift-atc-button', GiftAtcButton)
  if (!customElements.get('b2g-atc-button')) customElements.define('b2g-atc-button', B2gAtcButton)
  if (!customElements.get('gift-quickshop-opener')) customElements.define('gift-quickshop-opener', GiftQuickshopOpener)
})();